import React from 'react';
import { Alert } from '@mui/material';
import Box from '@mui/material/Box';

interface IProps {
  text: any
}

const ErrorComponent: React.FC<React.PropsWithChildren<IProps>> = ({ text }: IProps) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%'
    }}
  >
    <Alert severity="error">{typeof text === 'string' ? text : 'Error fetching data from server'}</Alert>
  </Box>
);

export default ErrorComponent;
